export default "__VITE_ASSET__BumTuDeC__"